import { InternalPermission } from 'src/constants/internal-access/internalPermissions'

/**
 * "Assign to invoice…" opens a modal that first lists the partner's pending invoices
 * (`GET /partners/:partnerId/invoices/pending`, `invoices_view`) and then assigns one
 * (`POST /payments/transactions/:id/assign-invoice`, `transactions_assign_invoice`). Either one
 * missing makes the modal useless, so both are required.
 */
export const canAssignTransactionInvoice = (permissions: string[]): boolean => {
  return (
    permissions.includes(InternalPermission.TransactionsAssignInvoice) &&
    permissions.includes(InternalPermission.InvoicesView)
  )
}

/** `POST /payments/refunds` (`refunds_initiate`) — creates a `created` refund, moves no money. */
export const canInitiateTransactionRefund = (permissions: string[]): boolean => {
  return permissions.includes(InternalPermission.RefundsInitiate)
}
